module.exports = __webpack_public_path__ + "assets/icon-plugin-deselected.f6626fdf.svg";